import { BehaviorSubject, Observable } from "rxjs";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { IGroupOrderGuideService } from "./groupOrderGuide.facade";

export class GroupOrderGuideService implements IGroupOrderGuideService {

  constructor(private _inHouseOrderService: InHouseOrderService) { }

  // !deferred. Name input on previous page
  /*
  private _user_name: string;
  public get user_name(): string {
    return this._user_name;
  }
  public set user_name(name: string) {
    this._user_name = name;
  }
  */

  public get groupName(): string {
    return this._inHouseOrderService.GroupName;
  }

  /** Gruppe ist voll */
  private _isGroupFullSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get isGroupFull$(): Observable<boolean> {
    return this._isGroupFullSubject.asObservable();
  }

  //??
  /** laut der Dokumentation soll hier auch geprüft werden, ob Link geteilt werden kann.
   Ist dies nicht überflüssig,user landet doch auf dieser Seite,erst wenn er gerade eine Gruppe erstellt hat?*/

  //?add group, creator name.. on navigation (property)

}